export default __webpack_public_path__ + "static/media/Etterbeek2.9c1532eb.png";